import { render, staticRenderFns } from "./SavedGroup.vue?vue&type=template&id=38dc139f"
import script from "./savedGroup.ts?vue&type=script&lang=ts&external"
export * from "./savedGroup.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38dc139f')) {
      api.createRecord('38dc139f', component.options)
    } else {
      api.reload('38dc139f', component.options)
    }
    module.hot.accept("./SavedGroup.vue?vue&type=template&id=38dc139f", function () {
      api.rerender('38dc139f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/shared/team-request-detail/buttons-group/groups/client/saved-group/SavedGroup.vue"
export default component.exports